import type { App } from '../app/App';
import { CHANGELOG } from '../game/data/changelog';
import { language, t } from '../i18n';
import { modal } from './components';
import { h } from './dom';

const SEEN_KEY = 'paper-legends/changelog-seen';

/** True while the newest Update Log entry has not been opened on this device. */
export function changelogUnseen(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) !== CHANGELOG[0]?.version;
  } catch {
    return false;
  }
}

/** The Update Log: what each release brought, newest first. */
export async function openChangelog(app: App): Promise<void> {
  try {
    localStorage.setItem(SEEN_KEY, CHANGELOG[0]?.version ?? '');
  } catch {
    /* private mode: the dot just stays */
  }
  const lang = language();
  const day = (d: string): string => new Date(`${d}T12:00:00`).toLocaleDateString(lang === 'th' ? 'th-TH' : 'en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const body = h(
    'div',
    { class: 'changelog' },
    CHANGELOG.map((e, i) =>
      h(
        'section',
        { class: `changelog-entry ${i === 0 ? 'latest' : ''}` },
        h('h3', null, `v${e.version}`, h('small', null, ` · ${day(e.date)}`), i === 0 ? h('span', { class: 'changelog-new' }, t('NEW')) : null),
        h('ul', null, (lang === 'th' ? e.th : e.en).map((line) => h('li', null, line))),
      ),
    ),
  );
  app.sfx.play('flip');
  await modal(`📜 ${t('Update Log')}`, body, [{ label: t('Close'), value: 'close', variant: 'primary' }], { className: 'changelog-modal' });
}
